import React from 'react';
import PropTypes from 'prop-types';
import phone from '../../../../../../../images/phone.svg';

const MobileTooltip = ({ children }) => (
  <span className="c-info-tooltip-new-handler">
    <div className="c-info-tooltip-new__content">
      Clients who signed up through Squire cannot be merged into another customer.
      Please reach out to customer service for assistance.
    </div>
    <img src={phone} style={{ width: '15px' }} alt="mobile" />
    {children}
  </span>
);

MobileTooltip.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MobileTooltip;
